import { DraftGroup } from '@core/filters/path-filter/draft';

export type GroupMode = 'all' | 'any' | 'none';

/** None is a negated `or`: not one of the children holds. */
export const GROUP_MODES: Record<GroupMode, Pick<DraftGroup, 'connector' | 'negated'>> = {
  all: { connector: 'and', negated: false },
  any: { connector: 'or', negated: false },
  none: { connector: 'or', negated: true }
};

export function groupModeOf(group: DraftGroup): GroupMode {
  if (group.negated) return 'none';
  return group.connector === 'and' ? 'all' : 'any';
}
